// eslint-disable-next-line import/prefer-default-export
export const CHART_TYPE = {
  CHART_LINE: 'chart_line', // 折线图
  NUMBER_TYPE: 'number', // 数值
  TABLE: 'table', // 表格
  HISTOGRAM: 'histogram', // 柱状图
  CIRCULAR_GRAPH: 'circular_graph', // 环形图
  STACKED_BAR_CHART: 'stacked_bar_chart', // 堆叠条形图
  FUNNEL_CHART: 'funnel_chart', // 漏斗图
  SANKEY_CHART: 'sankey_chart', // 桑基图
};
